import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { HeadTitle } from '../../CustomizedComponents/Texts';
import SectionWrapper from '../../CardRow/SectionWrapper';
import DetailWrapper from '../../CardRow/DetailWrapper';
import { FormattedMessage } from 'react-intl';
import CustomTextField from '../../CustomizedComponents/CustomTextField';
import ButtonWrapper from '../../Button/ButtonWrapper';
import DefaultButton from '../../Button/DefaultButton';
import CustomCheckBox from '../../CustomizedComponents/CustomCheckBox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useForm } from 'react-hook-form';
import CustomNumberFormat from '../../CustomizedComponents/CustomNumberFormat';
import CustomSnackBar from '../../CustomizedComponents/CustomSnackbar';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import useAppContext from '../../../hooks/context/useAppContext';

const NotificationSettings = ({ notification, handlers, id }) => {
  const {
    products,
    productId,
    name,
    minPrice,
    maxPrice,
    sms,
    email,
    price,
    currencyId,
    postError,
    postLoading,
    putError,
    putLoading,
    deleteError,
    deleteLoading,
    postNotificationData,
    deleteData,
  } = notification;
  const { setProductId, setName, setMinPrice, setMaxPrice, setSms, setEmail, sendHandler, deleteNotifications } = handlers;
  const intl = useIntl();
  const { setBackNavigation } = useAppContext();

  const success = intl.formatMessage({ id: 'app.action.saved' });
  const dataMissing = intl.formatMessage({ id: 'app.data.missing' });
  const actualPriceTitle = intl.formatMessage({ id: 'app.watch.actualPrice' });
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(success);
  const [issues, setIssues] = useState(null);
  const { handleSubmit, register, errors } = useForm();
  const cancel = 'app.buttons.cancel';
  const save = 'app.buttons.save';
  const deleteTitle = 'app.buttons.delete';
  const history = useHistory();
  const [editable, setEditable] = useState(true);
  const overview = `/pricealert`;

  const handleChange = (idButton) => {
    if (idButton !== 'cancel' && idButton !== 'delete') {
      setOpen(true);
      sendHandler();
    } else if (idButton === 'delete') {
      deleteNotifications(id);
    } else {
      history.push(overview);
    }
  };
  useEffect(() => {
    setEditable(![postLoading, deleteLoading, putLoading]?.some((item) => item === true));
  }, [postLoading, deleteLoading, setEditable, putLoading]);

  useEffect(() => {
    if (!deleteError && !deleteLoading && deleteData) {
      setOpen(true);
      history.push(overview);
    }
  }, [deleteError, deleteLoading, deleteData, history, overview]);

  useEffect(() => {
    setBackNavigation(overview);
  }, [setBackNavigation, overview]);

  useEffect(() => {
    setEditable(![postLoading, deleteLoading, putLoading]?.some((item) => item === true));
  }, [postLoading, deleteLoading, setEditable, putLoading]);

  useEffect(() => {
    if (putError) {
      setMessage(putError?.data?.message);
      setIssues(putError?.data?.issues);
    } else if (postError) {
      setMessage(postError?.data?.message);
      setIssues(postError?.data?.issues);
    } else {
      setMessage(success);
      setIssues(null);
    }
    postNotificationData && history.push(`/price-alert/${postNotificationData.id}`);
  }, [postError, putError, success, postNotificationData, history]);

  return (
    <>
      <DetailWrapper>
        <form onSubmit={handleSubmit(handleChange)}>
          <SectionWrapper>
            <HeadTitle title={'app.watch.card'} />
            <CustomTextField
              id="name"
              name={'name'}
              onChange={(event) => {
                setName(event.target.value);
              }}
              label={<FormattedMessage id={'app.watch.title'} />}
              value={name}
              variant="outlined"
              inputRef={register({
                required: dataMissing,
              })}
              helperText={errors?.name?.message}
              error={errors?.name}
              disabled={!editable}
            />
            <CustomTextField
              id="productId"
              name={'productId'}
              onChange={(event) => {
                setProductId(event.target.value);
              }}
              disabled={id === 'new' ? false : true}
              select
              label={<FormattedMessage id={'app.watch.product'} />}
              value={productId}
              SelectProps={{
                native: true,
              }}
              variant="outlined"
              inputRef={register({
                required: dataMissing,
              })}
              error={errors?.productId}
              helperText={`${actualPriceTitle} ${price} ${currencyId}`}>
              <option value={null} />
              {products.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </CustomTextField>
            <CustomTextField
              id="minPrice"
              name="minPrice"
              onChange={(event) => setMinPrice(event.target.value)}
              label={<FormattedMessage id={'app.watch.priceBelow'} />}
              value={minPrice}
              variant="outlined"
              disabled={!editable}
              inputRef={register({
                required: dataMissing,
              })}
              helperText={errors?.minPrice?.message}
              error={errors?.minPrice}
              InputProps={{
                inputComponent: CustomNumberFormat,
                endAdornment: <div>{currencyId}</div>,
              }}
            />
            <CustomTextField
              id="maxPrice"
              name="maxPrice"
              onChange={(event) => setMaxPrice(event.target.value)}
              label={<FormattedMessage id={'app.watch.priceOver'} />}
              value={maxPrice}
              variant="outlined"
              disabled={!editable}
              inputRef={register({
                required: dataMissing,
              })}
              helperText={errors?.maxPrice?.message}
              error={errors?.maxPrice}
              InputProps={{
                inputComponent: CustomNumberFormat,
                endAdornment: <div>{currencyId}</div>,
              }}
            />
            <FormGroup>
              <FormControlLabel
                control={<CustomCheckBox checked={email} disabled={!editable} onChange={(event) => setEmail(event.target.checked)} />}
                label={<FormattedMessage id={'app.notification_email'} />}
              />
              <FormControlLabel
                control={<CustomCheckBox checked={sms} disabled={!editable} onChange={(event) => setSms(event.target.checked)} />}
                label={<FormattedMessage id={'app.notification_sms'} />}
              />
            </FormGroup>
          </SectionWrapper>
          <ButtonWrapper>
            <DefaultButton
              id={'cancel'}
              primary={false}
              title={cancel}
              disabled={!editable}
              onClick={(event) => {
                handleChange(event.currentTarget.id);
              }}
            />
            {id !== 'new' && (
              <DefaultButton
                id={'delete'}
                primary={false}
                title={deleteTitle}
                disabled={!editable}
                onClick={(event) => {
                  handleChange(event.currentTarget.id);
                }}
                loaders={[deleteLoading]}
              />
            )}
            <DefaultButton primary={true} type="submit" title={save} disabled={!editable} loaders={[postLoading, putLoading]} />
          </ButtonWrapper>
        </form>
        {!postLoading && !putLoading && !deleteLoading && !!message && (
          <CustomSnackBar status={postError || putError ? 'error' : 'success'} message={message} setOpen={setOpen} open={open} />
        )}
        {!postLoading &&
          !putLoading &&
          !deleteLoading &&
          !!issues &&
          issues.map((issue) => <CustomSnackBar key={issue} status={'error'} message={issue} setOpen={setOpen} open={open} />)}
      </DetailWrapper>
    </>
  );
};

NotificationSettings.propTypes = {
  notification: PropTypes.object,
  handlers: PropTypes.object,
  editable: PropTypes.bool,
  isNew: PropTypes.bool,
  id: PropTypes.any,
  loading: PropTypes.bool,
};

export default NotificationSettings;
